import { render, staticRenderFns } from "./VEmployeeCompany.vue?vue&type=template&id=45745a89&scoped=true&lang=pug"
import script from "./VEmployeeCompany.vue?vue&type=script&lang=ts"
export * from "./VEmployeeCompany.vue?vue&type=script&lang=ts"
import style0 from "./VEmployeeCompany.vue?vue&type=style&index=0&id=45745a89&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45745a89",
  null
  
)

export default component.exports